import {
  hearts,
  weather,
  numerals,
  currencies,
  math,
  arrows,
  smileys,
  music,
  stars,
} from './symbolsData';
import { categoryPageId, PAGE_TYPE } from './pageIds';

export const symbolsByCategory = {
  [categoryPageId.hearts]: hearts,
  [categoryPageId.weather]: weather,
  [categoryPageId.math]: math,
  [categoryPageId.stars]: stars,
  [categoryPageId.arrows]: arrows,
  [categoryPageId.currencies]: currencies,
  [categoryPageId.smileys]: smileys,
  [categoryPageId.music]: music,
  [categoryPageId.numerals]: numerals,
};

export const categoryPageData = {
  [categoryPageId.hearts]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/60962180759202050072.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/35600565893276612437.webp',
        width: 464,
        height: 335,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.weather]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/53313963756953706838.webp',
        width: 413,
        height: 274,
      },
      {
        url: 'https://cdn140.picsart.com/16526846570724207058.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.numerals]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/19308779025695032317.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/37035699726885984873.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.currencies]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/68329133432521969010.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/94665335789496128342.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.math]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/36120251141422862234.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/03290474015374856787.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.arrows]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/56835547850135568601.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/07708648427041898321.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.smileys]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/50957437832036906289.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/92045248490631112768.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.music]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/62016834554104277733.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/27994165033948442803.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
  [categoryPageId.stars]: {
    imgs: [
      {
        url: 'https://cdn140.picsart.com/26769486694382743403.webp',
        width: 464,
        height: 334,
      },
      {
        url: 'https://cdn140.picsart.com/50663375727593762128.webp',
        width: 464,
        height: 334,
      },
    ],
    type: PAGE_TYPE.category,
  },
};
